import { APP_VERSION } from '@Constants/runtimeConstants';
import { type OnAfterRequestHandler, useToasts } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import semverSatisfies from 'semver/functions/satisfies';

export const refreshRequestCoolDownMilliseconds = 1 * 60 * 1000; // 1min

export const refreshTimeStorageKey = 'synqo.cloud.refreshRequest';

export function shouldTellUserToRefresh(version: string): boolean {
    // We have an edge case where the commit hash includes a leading zero. That is not allowed as a valid pre-release identifier part.
    // Until we fix this by e.g. prefixing the parts we include the string comparison as a workaround
    if (APP_VERSION === version || semverSatisfies(APP_VERSION, version)) {
        return false;
    }
    const now = Date.now();
    const lastRefreshRequest = localStorage.getItem(refreshTimeStorageKey);
    if (lastRefreshRequest !== null && parseInt(lastRefreshRequest) + refreshRequestCoolDownMilliseconds > now) {
        return false;
    }

    localStorage.setItem(refreshTimeStorageKey, now.toString());
    return true;
}

export const useSynqoApiVersionCheck = (): OnAfterRequestHandler => {
    const { pushToast } = useToasts();

    return useCallback<OnAfterRequestHandler>(
        async (_, res) => {
            const version = res?.headers.get('Synqo-Version');
            if (!version) {
                return;
            }

            if (!shouldTellUserToRefresh(version)) {
                return;
            }

            pushToast({
                title: 'Eine neue Version ist verfügbar',
                message: 'Bitte aktualisieren Sie das Browserfenster um die neuste Synqo Version zu verwenden.',
                variant: 'info',
                timeout: 0,
            });
        },
        [pushToast],
    );
};
